import { ChatChannel } from "@/views/modules/messaging-inbox/useChat";
import { ChatsListChat } from "@saysimple-platform/dtos";
import { ref } from "@vue/composition-api";

const ctxMenu = ref<HTMLDivElement | null>(null);
const ctxChat = ref<ChatsListChat | null>(null);
const ctxAllowDelete = ref<boolean>(false);

export default function useChatsListContextMenu() {
    const showContextMenu = (chat: ChatsListChat, channel: ChatChannel) => {
        if (!ctxMenu.value || !chat || !channel) {
            return;
        }

        ctxChat.value = chat;

        const settings = channel.settings;
        ctxAllowDelete.value = settings?.find((setting) => setting.name === "allowDeleteConversation")?.value === "1";

        // @ts-ignore
        ctxMenu.value.open();
    };

    return {
        ctxAllowDelete,
        ctxChat,
        ctxMenu,
        showContextMenu,
    };
}
